module.exports = "/static/assets/911ef52fdb429b1c3e80a364a1f17d7f.png";